const CircleSkeleton = ({ size = "100px" }) => {
    return (
        <div className="skeleton" style={{
            height: size,
            width: size,
            borderRadius: "50%"
        }} />
    );
};

export default CircleSkeleton;
